/**
 * Menvora Analytics — transport compartido (GA4 + Meta custom + dataLayer).
 * Context envelope: product_handle / view / path / cod_session_id en cada hit.
 * Usado por menvora-pdp-analytics.js, menvora-cod-funnel.js, menvora-cod-prefill.js.
 * gtag/fbq se flushean en idle (INP); dataLayer es síncrono. beacon/pagehide flushean ya.
 */
(function () {
  if (window.MenvoraAnalytics) return;

  var GA4_ID = window.MENVORA_GA4_ID || 'G-CBPPJXZR4H';

  function sanitize(v) {
    return String(v || 'unknown')
      .replace(/[^a-zA-Z0-9_.\- ]/g, '_')
      .slice(0, 80);
  }

  function readPdp() {
    return window.MENVORA_PDP || {};
  }

  function readCodSession() {
    var s = window.__menvoraCodSession;
    if (!s || typeof s !== 'object') return null;
    return s;
  }

  /**
   * Envelope de contexto. Params del caller pisan claves explícitas.
   * No envía PII.
   */
  function buildEnvelope(params) {
    var cfg = readPdp();
    var sess = readCodSession();
    var path = '';
    try {
      path = (location.pathname || '').slice(0, 80);
    } catch (e) {
      path = '';
    }
    var base = {
      product_handle: sanitize(cfg.productHandle || 'unknown'),
      template: sanitize(cfg.template || 'product'),
      view: sanitize(cfg.view || 'default'),
      lp: sanitize(cfg.lp || ''),
      angle: sanitize(cfg.angle || ''),
      path: sanitize(path),
      ads_stacked: cfg.adsStacked ? 1 : 0,
    };
    if (sess && sess.id) {
      base.cod_session_id = sanitize(sess.id);
    }
    var payload = params || {};
    var out = {};
    var k;
    for (k in base) {
      if (Object.prototype.hasOwnProperty.call(base, k)) out[k] = base[k];
    }
    for (k in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, k)) {
        var v = payload[k];
        // No clobber envelope con undefined/null vacío salvo override explícito string/number
        if (v === undefined) continue;
        out[k] = v;
      }
    }
    return out;
  }

  function setCodSession( partial) {
    var cur = readCodSession() || {};
    var next = {};
    var k;
    for (k in cur) {
      if (Object.prototype.hasOwnProperty.call(cur, k)) next[k] = cur[k];
    }
    if (partial && typeof partial === 'object') {
      for (k in partial) {
        if (Object.prototype.hasOwnProperty.call(partial, k)) next[k] = partial[k];
      }
    }
    window.__menvoraCodSession = next;
    return next;
  }

  function clearCodSession() {
    try {
      delete window.__menvoraCodSession;
    } catch (e) {
      window.__menvoraCodSession = null;
    }
  }

  function queueHasInit() {
    var q = window.fbq && window.fbq.queue;
    if (!Array.isArray(q)) return false;
    for (var i = 0; i < q.length; i++) {
      var a = q[i];
      if (a && a[0] === 'init') return true;
    }
    return false;
  }

  /** Evita trackCustom antes de fbq('init') (Meta Pixel Helper: Track event before pixel init). */
  function fbqReadyForTrack() {
    if (typeof window.fbq !== 'function') return false;
    try {
      if (typeof window.fbq.getState === 'function') {
        var st = window.fbq.getState();
        if (st && st.pixels && st.pixels.length) return true;
      }
    } catch (e) {}
    // Stub Meta: init ya encolado por Shopify/app → seguro encolar trackCustom después
    if (queueHasInit()) return true;
    return false;
  }

  var pixelQueue = [];
  var pixelFlushScheduled = false;
  var pixelPollId = null;
  var pixelPollCount = 0;
  var pagehideBound = false;

  function scheduleIdle(fn) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(function () {
        fn();
      }, { timeout: 2000 });
    } else {
      window.setTimeout(fn, 0);
    }
  }

  function trySendItem(item) {
    if (!item.fbqDone) {
      try {
        if (fbqReadyForTrack()) {
          window.fbq('trackCustom', item.name, item.payload);
          item.fbqDone = true;
        }
      } catch (e) {}
    }
    if (!item.gtagDone) {
      try {
        if (typeof window.gtag === 'function') {
          var gaParams = {};
          var k;
          for (k in item.payload) {
            if (Object.prototype.hasOwnProperty.call(item.payload, k)) gaParams[k] = item.payload[k];
          }
          gaParams.send_to = GA4_ID;
          if (item.opts && item.opts.transport_type) gaParams.transport_type = item.opts.transport_type;
          window.gtag('event', item.name, gaParams);
          item.gtagDone = true;
        }
      } catch (e2) {}
    }
    return !!(item.fbqDone && item.gtagDone);
  }

  function startPixelPoll() {
    if (pixelPollId) return;
    pixelPollCount = 0;
    pixelPollId = setInterval(function () {
      pixelPollCount += 1;
      flushPixels();
      if (!pixelQueue.length || pixelPollCount > 50) {
        clearInterval(pixelPollId);
        pixelPollId = null;
      }
    }, 200);
  }

  /**
   * gtag/fbq fuera del click path (INP). dataLayer sigue inmediato.
   * beacon / pagehide flushean ya para no perder el hit.
   */
  function flushPixels() {
    pixelFlushScheduled = false;
    if (!pixelQueue.length) return;
    var still = [];
    var i;
    for (i = 0; i < pixelQueue.length; i++) {
      if (!trySendItem(pixelQueue[i])) still.push(pixelQueue[i]);
    }
    pixelQueue = still;
    if (pixelQueue.length) startPixelPoll();
  }

  function bindPagehideFlush() {
    if (pagehideBound) return;
    pagehideBound = true;
    function onHidden() {
      flushPixels();
    }
    window.addEventListener('pagehide', onHidden);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') onHidden();
    });
  }

  function track(name, params, options) {
    var payload = buildEnvelope(params);
    var opts = options || {};

    // dataLayer siempre inmediato (no depende de librerías externas)
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) {}

    bindPagehideFlush();
    pixelQueue.push({
      name: name,
      payload: payload,
      opts: opts,
      fbqDone: false,
      gtagDone: false,
    });

    if (opts.transport_type === 'beacon') {
      flushPixels();
      return;
    }

    if (pixelFlushScheduled) return;
    pixelFlushScheduled = true;
    scheduleIdle(flushPixels);
  }

  window.MenvoraAnalytics = {
    GA4_ID: GA4_ID,
    sanitize: sanitize,
    track: track,
    flushPixels: flushPixels,
    buildEnvelope: buildEnvelope,
    setCodSession: setCodSession,
    clearCodSession: clearCodSession,
  };
})();
